import React, { FC } from "react"
import { SendMessageFormContainer } from "../../../containers/talktocarrot/SendMessageFormContainer"
import { TalkToCarrotBenefitEnrollmentFlowView } from "./TalkToCarrotBenefitEnrollmentFlowView"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"

interface TalkToCarrotModalContainerProps {
  onExit: () => void
}

const TalkToCarrotModalContainer: FC<TalkToCarrotModalContainerProps> = ({ onExit }) => {
  const { previousStep } = useStateMachine()
  return (
    <SendMessageFormContainer
      modalTopic={previousStep.name}
      BenefitEnrollmentView={TalkToCarrotBenefitEnrollmentFlowView}
      onExit={onExit}
    />
  )
}

export { TalkToCarrotModalContainer }
